/** Teams UI labels — DB role `field_officer` is shown as Installation member. */

export const ROLE_LABELS = {
  'project-manager': 'Project Manager',
  field_officer: 'Field Officer',
  accountant: 'Accountant',
  'store-manager': 'Store Incharge',
  owner: 'Owner',
  admin: 'Admin',
  designer: 'Designer',
  telecaller: 'Telecaller',
  sales_executive: 'Sales Executive',
  carpenter: 'Carpenter',
  electrician: 'Electrician',
  painter: 'Painter',
  plumber: 'Plumber'
};

export const formatTeamRoleLabel = (role) => ROLE_LABELS[role] || role?.replace(/_/g, ' ') || '—';

export const INSTALLATION_TRADES = [
  { value: 'carpenter', label: 'Carpenter' },
  { value: 'electrician', label: 'Electrician' },
  { value: 'painter', label: 'Painter' },
  { value: 'plumber', label: 'Plumber' }
];

export const formatInstallationTrade = (trade) =>
  INSTALLATION_TRADES.find((t) => t.value === trade)?.label || '—';

export const getRoleBadgeStyle = (role) => {
  const normalized = String(role || '').toLowerCase();
  switch (normalized) {
    case 'owner':
      return 'bg-amber-50 text-amber-700 border-amber-200/50';
    case 'admin':
      return 'bg-rose-50 text-rose-700 border-rose-200/50';
    case 'project-manager':
      return 'bg-indigo-50 text-indigo-700 border-indigo-200/50';
    case 'accountant':
      return 'bg-orange-50 text-orange-700 border-orange-200/50';
    case 'designer':
      return 'bg-pink-50 text-pink-700 border-pink-200/50';
    case 'sales_executive':
      return 'bg-orange-50 text-orange-700 border-orange-200/50';
    case 'telecaller':
      return 'bg-sky-50 text-sky-700 border-sky-200/50';
    case 'field_officer':
    case 'field-officer':
      return 'bg-teal-50 text-teal-700 border-teal-200/50';
    case 'store-manager':
      return 'bg-cyan-50 text-cyan-700 border-cyan-200/50';
    default:
      return 'bg-slate-50 text-slate-700 border-slate-200/50';
  }
};
